export const BOOKINGS_RETRIEVED = 'BOOKINGS_RETRIEVED';
export const CARS_RETRIEVED = 'CARS_RETRIEVED';
export const SHIFTS_RETRIEVED = 'SHIFTS_RETRIEVED';
export const PARKINGLOTS_RETRIEVED = 'PARKINGLOTS_RETRIEVED';
export const NEWSFEEDS_RETRIEVED = 'NEWSFEEDS_RETRIEVED';

export const LOAD_UPCOMING_SHIFT = 'LOAD_UPCOMING_SHIFT';
export const CHANGE_BOOKING_DETAIL = 'CHANGE_BOOKING_DETAIL';
export const SHIFT_CANCELLED = 'SHIFT_CANCELLED';
export const REMOVE_FROM_BOOKINGS = 'REMOVE_FROM_BOOKINGS';
export const UPDATE_LOCKBOX = 'UPDATE_LOCKBOX';



// WEBPACK FOOTER //
// ./src/constants/index.js